import moment from "moment";
import { useEffect, useState } from "react";
import { DetailsCardProps } from "../../../components/detailsCard/detailsCard";
import { DraftSubmission } from "../../../data-model/draftSubmission";
import { CopyIcon } from "../../../svg/copy-icon";

export const useAuthInfoDataGeneration = (
  authInformation?: DraftSubmission,
) => {
  const [authInfoData, setAuthInfoData] = useState<
    DetailsCardProps | undefined
  >(undefined);
  useEffect(() => {
    if (authInformation) {
      const detailsCardData: DetailsCardProps = {
        elementsInOneRow: 3,
        showBorder: false,
        details: [
          {
            header: "ID",
            text: authInformation?.auth_id ?? "",
            iconRight: <CopyIcon />,
            onClick: (text) => {
              navigator.clipboard.writeText(text ?? "");
            },
          },
          {
            header: "Payer Portal",
            text: authInformation?.payer_portal ?? "",
          },
          {
            header: "Draft Creation Date",
            text:
              moment(authInformation?.created_at).format("DD MMM YYYY") ?? "",
          },
          {
            header: "Plan Name",
            text: authInformation?.plan_name ?? "",
            iconRight: <CopyIcon />,
            onClick: (text) => {
              navigator.clipboard.writeText(text ?? "");
            },
          },
          {
            header: "Member ID",
            text: authInformation?.member_id ?? "",
            iconRight: <CopyIcon />,
            onClick: (text) => {
              navigator.clipboard.writeText(text ?? "");
            },
          },
          {
            header: "Provider",
            text: authInformation?.provider_name ?? "",
          },
          {
            header: "Comments",
            text: authInformation?.comments ?? "",
            allowExpansion: true,
          },
        ],
      };
      setAuthInfoData(detailsCardData);
    }
  }, [authInformation]);
  return authInfoData;
};
